import { useTranslation } from 'react-i18next';

const useProjectSizeSchema = (props) => {
    const { t } = useTranslation();

    let projectSizeSchema = {
        id: "projectSizeSchema",
        elements: [
            {
                type: "grid",
                direction: 'row',
                spacing: 2,
                elements: [
                    {

                        type: "text",
                        name: 'name',
                        label: t('name'),
                        item: {
                            xs: 12
                        },
                        validators: [
                            {
                                name: 'required',
                                config: {
                                    msg: t('name_is_required')
                                }
                            },
                        ]
                    },
                    {
                        type: 'grid'
                    }
                ]
            }

        ]
    }


    return {
        projectSizeSchema
    }

}

export default useProjectSizeSchema;
